import React from 'react';

import { GridFieldCell } from './cells/GridCell';
import { GridColumnContext } from './context/GridColumnContext';
import { useGridContext } from './context/GridContext';
import { GridFiller } from './GridFiller';
import { GridCellsProps } from './types';
import { cellCSS } from './utils';

import cn from './Grid.module.scss';

export const GridCellsPhantom = ({ index, theme }: GridCellsProps) => {
  const {
    columns,
    cumulative_fixed_left_widths,
    cumulative_fixed_right_widths,
    cumulative_column_widths,
    column_widths,
    row_height,
    filler_required,
  } = useGridContext();

  return (
    <React.Fragment>
      {columns.map((column, idx) => {
        const width = column_widths[idx];

        const style = cellCSS({
          height: row_height,
          fixed: column.props.fixed,
          index: idx,
          width,
          filler_required,
          cumulative_column_widths,
          cumulative_fixed_right_widths,
          cumulative_fixed_left_widths,
        });

        return (
          <GridColumnContext.Provider
            value={{ column: column.props }}
            key={`phantom-cell-${index}-${idx}`}
          >
            <div
              key={`phantom-cell-${index}-${idx}`}
              className={cn.boundary}
              style={{
                ...style,
                padding: theme.padding,
                borderColor: theme.border_color,
                background: theme.background,
              }}
            >
              <GridFieldCell />
            </div>
          </GridColumnContext.Provider>
        );
      })}
      <GridFiller height={row_height} theme={theme} />
    </React.Fragment>
  );
};
